import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../../../core/Icon';
import connect from '../../../../core/EcrionProvider/connect';
import _logoutUser from '../../actions/logoutUser';
import { getDisplayName } from '../../util';

var styles = function styles(theme) {
  return createStyles({
    userBox: {
      color: '#FFF',
      height: theme.common.Page.NavBar.style.height,
      cursor: 'pointer',
      userSelect: 'none',
      borderRadius: 0,
      '&:hover, &:focus': {
        backgroundColor: darken(theme.common.Page.NavBar.style.backgroundColor, 0.2)
      }
    },
    userBoxOpened: {
      backgroundColor: darken(theme.common.Page.NavBar.style.backgroundColor, 0.2)
    },
    userNameTextContent: {
      color: '#FFF',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5)
    },
    userNameTextArea: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    downCaret: {
      marginTop: 5,
      fontSize: 14
    }
  });
};
/**
 * @extends {React.Component<Props, State>}
 * @typedef {{ anchorEl: HTMLElement }} State
 */


var NavBarUser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavBarUser, _React$Component);

  function NavBarUser() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NavBarUser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavBarUser)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      anchorEl: null
    };

    _this.handleClick = function (e) {
      _this.setState({
        anchorEl: e.currentTarget
      });
    };

    _this.handleClose = function () {
      return _this.setState({
        anchorEl: null
      });
    };

    _this.handleLogOut = function () {
      _this.props.logoutUser();

      _this.handleClose();
    };

    _this.renderResponsiveItems = function () {
      var mediaQuery = _this.props.theme.breakpoints.down('xs').replace('@media ', '');

      if (window.matchMedia(mediaQuery).matches) {
        return React.createElement(MenuItem, {
          onClick: function onClick() {
            return window.open('/EOS/Task/#task/Tasks');
          }
        }, "Tasks");
      }

      return null;
    };

    return _this;
  }

  _createClass(NavBarUser, [{
    key: "render",
    value: function render() {
      var _cx;

      var classes = this.props.classes;
      var anchorEl = this.state.anchorEl;
      return React.createElement(React.Fragment, null, React.createElement(Button, {
        "aria-owns": anchorEl ? 'navbar-user-dropdown' : undefined,
        "aria-haspopup": "true",
        onClick: this.handleClick,
        className: cx((_cx = {}, _defineProperty(_cx, classes.userBox, true), _defineProperty(_cx, classes.userBoxOpened, !!anchorEl), _cx))
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true,
        className: classes.userNameTextArea
      }, React.createElement(Typography, {
        className: classes.userNameTextContent
      }, getDisplayName(this.props.userInfo))), React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, {
        type: "down-filled",
        className: classes.downCaret
      })))), React.createElement(Menu, {
        id: "navbar-user-dropdown",
        anchorEl: anchorEl,
        open: !!anchorEl,
        onClose: this.handleClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        getContentAnchorEl: null
      }, this.renderResponsiveItems(), React.createElement(MenuItem, {
        onClick: this.handleLogOut
      }, "Logout")));
    }
  }]);

  return NavBarUser;
}(React.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logoutUser: function logoutUser() {
      return dispatch(_logoutUser());
    }
  };
};
/**
 * @typedef {Object} Props
 * @property {Object} [userInfo] User's display name
 * @property {Object} [classes] Injected by HoC
 * @property {Function} [logoutUser] Injected by HoC
 * @property {Object} [theme] Injected by HoC
 */


export default connect(null, mapDispatchToProps)(withStyles(styles, {
  withTheme: true,
  name: 'ECNavBarUser'
})(NavBarUser));